export class ApplicantNotes {
    public contactid: number;
    public note: string;
    public noteSubject: string;
    public addedBy: number;
    public addedByUsername: string;
    public DateAdded: string;
  }